import { j as e } from "./jsx-runtime-3tyXYecC.mjs";
import { createContext as O, forwardRef as H, useContext as D, useState as m, useEffect as T } from "react";
import { I as v } from "./icon-v2-DGtVEk7e.mjs";
import { T as _ } from "./tooltip-Cy1xtUCm.mjs";
import { m as b } from "./tss-DN0acMKN.mjs";
import { M as F, d as E } from "./constants-CnFYFetN.mjs";
import { B as W } from "./body-text-BiQwh5-U.mjs";
import { L as G } from "./link-unstyled-CvXR-8s6.mjs";
import { F as I } from "./flex-Cc3osQLf.mjs";
import { L as z } from "./layout-box-DFBM-kSI.mjs";
import { D as M } from "./divider-Dq5lrAFK.mjs";
import { M as A } from "./menu-63UgiRJf.mjs";
const Q = b()((n) => {
  const { mode: a, spacing: t } = n;
  return {
    footer: {
      bottom: t(3),
      display: "grid",
      gap: t(1.5),
      position: "sticky"
    },
    links: {
      display: "grid",
      gap: t(1),
      overflowX: "hidden",
      overflowY: "auto"
    },
    root: {
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      gap: t(2),
      height: "100%",
      justifyContent: "space-between",
      outline: a === F.Dye ? `1px solid ${E.main}` : void 0,
      padding: t(3),
      width: "fit-content"
    }
  };
}), N = O({ open: !0 }), P = b()(({ constructs: n, mixins: a, palette: t, spacing: r }) => ({
  root: {
    alignItems: "center",
    backgroundColor: t.gray[100],
    borderRadius: "16px",
    display: "flex",
    fill: n.icon.neutral.xStrong,
    height: r(6),
    justifyContent: "center",
    overflow: "hidden",
    width: r(6),
    "&:has(:focus-visible)": {
      boxShadow: `0px 0px 0px 2px ${a.alpha(n.surface.primary.strong, 0.8)}`
    },
    "&:hover": {
      fill: t.primary.main
    }
  },
  link: {
    alignItems: "center",
    display: "flex",
    height: "100%",
    justifyContent: "center",
    textDecoration: "none",
    width: "100%"
  }
})), U = b()(() => ({
  root: {
    alignItems: "center",
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    display: "flex",
    height: "100%",
    justifyContent: "center",
    width: "100%"
  }
})), B = H(({ children: n, ...a }, t) => {
  const { classes: r } = U();
  return /* @__PURE__ */ e.jsx("button", { type: "button", ...a, className: r.root, ref: t, children: n });
});
function R({ ariaLabel: n, biId: a, children: t, containerRef: r, href: c, onClick: i }) {
  const { classes: s } = P(), o = () => i ? /* @__PURE__ */ e.jsx(B, { "aria-label": n, "data-bi-id": a, onClick: i, children: t }) : c ? /* @__PURE__ */ e.jsx("a", { "aria-label": n, className: s.link, "data-bi-id": a, href: c, children: t }) : t;
  return /* @__PURE__ */ e.jsx("li", { className: s.root, ref: r, children: o() });
}
const f = 200, V = b()((n, a, t) => {
  const { constructs: r, mixins: c, palette: i, spacing: s, typography: o } = n;
  return {
    active: {
      fontWeight: o.fontWeightBold
    },
    centerIcon: {
      alignItems: "center",
      display: "inline-flex",
      justifyContent: "center"
    },
    hideLabel: {
      display: "none"
    },
    icon: {
      alignSelf: "flex-start",
      flex: "0 0 auto",
      height: "24px",
      width: "24px"
    },
    label: {
      alignItems: "start",
      display: "flex",
      flexDirection: "column",
      flexShrink: 0,
      maxWidth: "140px",
      minWidth: 0,
      opacity: 0,
      textAlign: "start",
      transition: `opacity ${f}ms ease-in-out`,
      wordBreak: "break-word"
    },
    link: {
      borderRadius: "16px",
      boxSizing: "border-box",
      color: i.gray[800],
      display: "flex",
      fill: i.gray[800],
      flexWrap: "nowrap",
      fontSize: o.medium.fontSize,
      fontWeight: o.fontWeightMedium,
      lineHeight: o.large.lineHeight,
      minHeight: "48px",
      padding: s(1.5),
      textDecoration: "none",
      transition: `width ${f}ms ease-in-out`,
      width: "48px",
      [`&:hover, &.${t.active}`]: {
        backgroundColor: i.gray[100],
        color: i.primary.main,
        fill: i.primary.main,
        textDecoration: "none"
      },
      "&:focus-visible": {
        outline: `2px solid ${c.alpha(r.border.primary.strong, 0.8)}`,
        outlineOffset: "-2px"
      }
    },
    open: {
      width: "200px",
      [`& .${t.label}`]: {
        opacity: 1
      }
    },
    root: {
      listStyleType: "none"
    }
  };
});
function X({
  active: n,
  activeIcon: a,
  ariaLabel: t,
  biId: r,
  divider: c = !1,
  external: i = !1,
  href: s,
  icon: o,
  label: p,
  note: x,
  containerRef: S,
  onClick: g
}) {
  const { open: l } = D(N), { classes: d, cx: u } = V(), [h, j] = m(l), [w, y] = m(l);
  let C = t || "";
  return typeof p == "string" && (C = p), T(() => {
    l ? (j(!1), setTimeout(() => {
      y(!0);
    }, 5)) : (y(!1), setTimeout(() => {
      j(!0);
    }, f));
  }, [l]), /* @__PURE__ */ e.jsxs("li", { className: d.root, children: [
    c ? /* @__PURE__ */ e.jsx(z, { width: l ? "200px" : "48px", children: /* @__PURE__ */ e.jsx(M, { color: "neutral-extra-weak", marginBottom: 1 }) }) : null,
    /* @__PURE__ */ e.jsx(
      G,
      {
        "aria-label": h ? C : void 0,
        biId: r,
        className: u(d.link, { [d.active]: n, [d.open]: w }),
        containerRef: S,
        href: s,
        onClick: (k) => {
          g && (k.preventDefault(), g(k));
        },
        target: i ? "_blank" : void 0,
        children: /* @__PURE__ */ e.jsxs(I, { gap: 1.5, width: "inherit", children: [
          /* @__PURE__ */ e.jsx("span", { className: u(d.icon, d.centerIcon), children: /* @__PURE__ */ e.jsx(v, { name: n ? a : o, size: 20 }) }),
          /* @__PURE__ */ e.jsxs("div", { className: u(d.label, { [d.hideLabel]: h }), children: [
            p,
            x ? /* @__PURE__ */ e.jsx(W, { color: "neutral-weak", size: "extra-extra-small", weight: "regular", children: x }) : null
          ] })
        ] })
      }
    )
  ] });
}
const Y = b()((n, a, t) => {
  const { constructs: r, mixins: c, palette: i, spacing: s, typography: o } = n;
  return {
    active: {
      fontWeight: o.fontWeightBold
    },
    button: {
      backgroundColor: "transparent",
      border: "none",
      borderRadius: "16px",
      boxSizing: "border-box",
      color: i.gray[800],
      cursor: "pointer",
      display: "flex",
      fill: i.gray[800],
      flexWrap: "nowrap",
      fontSize: o.medium.fontSize,
      fontWeight: o.fontWeightMedium,
      lineHeight: o.large.lineHeight,
      marginRight: s(1.5),
      minHeight: "48px",
      padding: s(1.5, 1, 1.5, 1.5),
      textDecoration: "none",
      transition: `width ${f}ms ease-in-out`,
      width: "48px",
      [`&:hover, &.${t.active}`]: {
        backgroundColor: i.gray[100],
        color: i.primary.main,
        fill: i.primary.main,
        textDecoration: "none"
      },
      "&:focus-visible": {
        outline: `2px solid ${c.alpha(r.border.primary.strong, 0.8)}`,
        outlineOffset: "-2px"
      }
    },
    centerIcon: {
      alignItems: "center",
      display: "inline-flex",
      justifyContent: "center"
    },
    hideLabel: {
      display: "none"
    },
    icon: {
      alignSelf: "flex-start",
      flex: "0 0 auto",
      height: "24px",
      width: "24px"
    },
    label: {
      alignItems: "start",
      display: "flex",
      flexDirection: "column",
      flexShrink: 0,
      maxWidth: "120px",
      minWidth: 0,
      opacity: 0,
      textAlign: "start",
      transition: `opacity ${f}ms ease-in-out`,
      wordBreak: "break-word"
    },
    open: {
      width: "200px",
      [`& .${t.label}`]: {
        opacity: 1
      }
    },
    root: {
      listStyleType: "none",
      marginRight: s(-1.5)
    }
  };
});
function q({
  active: n,
  activeIcon: a,
  ariaLabel: t,
  biId: r,
  divider: c = !1,
  icon: i,
  label: s,
  note: o,
  menuItems: p
}) {
  const { open: x } = D(N), [S, g] = m(!1), { classes: l, cx: d } = Y(), [u, h] = m(x), [j, w] = m(x);
  let y = t || "";
  return typeof s == "string" && (y = s), T(() => {
    x ? (h(!1), setTimeout(() => {
      w(!0);
    }, 5)) : (w(!1), setTimeout(() => {
      h(!0);
    }, f));
  }, [x]), /* @__PURE__ */ e.jsxs("li", { className: l.root, children: [
    c ? /* @__PURE__ */ e.jsx(z, { width: x ? "200px" : "48px", children: /* @__PURE__ */ e.jsx(M, { color: "neutral-extra-weak", marginBottom: 1 }) }) : null,
    /* @__PURE__ */ e.jsx(
      A,
      {
        biId: r,
        isOpen: S,
        items: p,
        onClose: () => g(!1),
        onOpen: () => g(!0),
        placement: {
          side: "right"
        },
        renderToggle: (C, k) => /* @__PURE__ */ e.jsx(
          "button",
          {
            ...k,
            "aria-label": u ? y : void 0,
            className: d(l.button, {
              [l.active]: n,
              [l.open]: j
            }),
            type: "button",
            children: /* @__PURE__ */ e.jsxs(I, { gap: 1, justifyContent: "space-between", width: "inherit", children: [
              /* @__PURE__ */ e.jsxs(I, { flexDirection: "row", gap: 1.5, children: [
                /* @__PURE__ */ e.jsx("span", { className: d(l.icon, l.centerIcon), children: /* @__PURE__ */ e.jsx(v, { name: n ? a : i, size: 20 }) }),
                /* @__PURE__ */ e.jsxs("div", { className: d(l.label, { [l.hideLabel]: u }), children: [
                  s,
                  o ? /* @__PURE__ */ e.jsx(W, { color: "neutral-weak", size: "extra-extra-small", weight: "regular", children: o }) : null
                ] })
              ] }),
              /* @__PURE__ */ e.jsx("span", { className: d(l.centerIcon, { [l.hideLabel]: u }), children: /* @__PURE__ */ e.jsx(v, { color: "neutral-strong", name: "caret-right-solid", size: 16 }) })
            ] })
          }
        )
      }
    )
  ] });
}
function L({ footer: n, links: a, open: t, onToggle: r }) {
  const { classes: c } = Q({ open: t }), [i, s] = m(), o = window.jQuery ? $.__("Collapse Menu") : "Collapse Menu", p = window.jQuery ? $.__("Expand Menu") : "Expand Menu";
  return /* @__PURE__ */ e.jsx(N.Provider, { value: { open: t }, children: /* @__PURE__ */ e.jsxs("nav", { className: c.root, "data-fabric-component": "GlobalNavigation", children: [
    /* @__PURE__ */ e.jsx("ul", { className: c.links, children: a }),
    /* @__PURE__ */ e.jsxs("ul", { className: c.footer, children: [
      n,
      /* @__PURE__ */ e.jsx(
        _,
        {
          anchorEl: i,
          content: t ? o : p,
          enterDelay: 150,
          placement: "right"
        }
      ),
      /* @__PURE__ */ e.jsx(
        R,
        {
          ariaLabel: t ? o : p,
          biId: "main-nav-toggle-btn",
          containerRef: s,
          onClick: r,
          children: /* @__PURE__ */ e.jsx(v, { name: "bars-regular", size: 20 })
        }
      )
    ] })
  ] }) });
}
L.FooterItemButton = B;
L.FooterItem = R;
L.Link = X;
L.LinkMenu = q;
export {
  L as G
};
//# sourceMappingURL=global-navigation-Bolg9Tn7.mjs.map
